import React, { FunctionComponent, useMemo } from 'react';

import Text from '@gojob/ui-bits/Text';
import BlockContent from '@sanity/block-content-to-react';

import internalLinkRenderer from '../../../Section/FootNotes/BlockRenderer/renderers/internalLinkRenderer';
import linkRenderer from '../../../Section/FootNotes/BlockRenderer/renderers/linkRenderer';

export type BlockRendererProps = {
  blocks?: any;
};

const spanRenderer = (props: any) => (
  <Text inactive variant="message4" css={{ textAlign: 'center' }}>
    {props.children}
  </Text>
);

const BlockRenderer: FunctionComponent<BlockRendererProps> = (props) => {
  const { blocks } = props;

  const serializers = useMemo(() => {
    return {
      types: { block: spanRenderer },
      hardBreak: false,
      marks: {
        link: linkRenderer,
        internal_link: internalLinkRenderer,
      },
    };
  }, []);

  if (!blocks) {
    return null;
  }
  return <BlockContent blocks={blocks} serializers={serializers} />;
};

export default BlockRenderer;
